import React from "react";
import translateService from "../../../common/translateService";

import "./LowerPriceMessage.scss";

const LowerPriceMessage = ({ lowerPrice }) => {
  return !_.isNil(lowerPrice) && !_.isEmpty(lowerPrice) ? (
    <div className="lower-price-message">
      <div className="prd-price-discount">
        <span style={{ fontSize: "0.8em", color: "#767676" }}>
          {translateService.interpolate(`lowerPrice.lowerPriceThanXDays`, {
            days: 30,
          })}
        </span>
        &nbsp;
        <small className="prd-price-old" style={{ fontSize: "0.8em" }}>
          <strong>{lowerPrice}</strong>
        </small>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default LowerPriceMessage;
